import { all, takeEvery, put } from 'redux-saga/effects';

import { sagaRequest } from '@ovpn-ui/utils';

import { settingsApi } from '../../api';

import { notificationRoutines as routines } from './slice';
import { getNotifications } from './api';

export function* loadPortalNotificationsSaga({
    payload: portal,
}: {
    payload: string;
    [key: string]: any;
}) {
    yield sagaRequest(getNotifications, settingsApi, portal)
        .some(function* (notes) {
            if (Array.isArray(notes)) {
                yield put(routines.setNotification(notes[0]));
            }
        })
        .run();
}

export default function* () {
    yield all([takeEvery(routines.loadNotifications, loadPortalNotificationsSaga)]);
}
